import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import { useTranslation } from "@i18n";
import { Link } from "react-router-dom";
import { CDN_LINK } from "@globalConfig";
import { onPushDataLayer } from "@/utils/events";
import stl from "./CashPayment.module.css";
import { cashCheckout1Event } from "@/utils/dataLayerEvents";
import { trackEvents } from "@/common/events/events";
import useHelpers from "@hooks/useHelpers";
import useContactNumbers from "@hooks/useContactNumbers";
import CarColorVariation from "@/pages/post/PostViewComponents/components/CarColorVariation/CarColorVariation";
var CashPayment = function CashPayment(_ref) {
  var _priceSection$none_va, _priceSection$none_va2, _priceSection$vat_pri, _priceSection$vat_pri2, _priceSection$old_pri, _priceSection$old_pri2, _priceSection$vat_pri3, _details$color_varian, _details$details_card, _details$details_card2, _details$details_card3, _details$details_card4;
  var priceSection = _ref.priceSection,
    postId = _ref.postId,
    ShowStory = _ref.ShowStory,
    arboun = _ref.arboun,
    hidePaymentBtn = _ref.hidePaymentBtn,
    reserved = _ref.reserved,
    g4_data = _ref.g4_data,
    details = _ref.details,
    gallery = _ref.gallery;
  var _useTranslation = useTranslation(["web_post_view", "web_common"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl,
    navigateToHard = _useHelpers.navigateToHard;
  var _useState = useState(false),
    showNumbers = _useState[0],
    setShowNumbers = _useState[1];
  var hasTowPrises = (priceSection === null || priceSection === void 0 ? void 0 : priceSection.none_vat_price) && (priceSection === null || priceSection === void 0 ? void 0 : priceSection.vat_price);
  var contactNumbers = useContactNumbers();
  var showImagesDisclaimer = function showImagesDisclaimer() {
    if ((gallery === null || gallery === void 0 ? void 0 : gallery.images.length) > 0) {
      var _gallery$images$filte, _gallery$images$filte2;
      var exteriorImages = (_gallery$images$filte = gallery.images.filter(function (item) {
        return (item === null || item === void 0 ? void 0 : item.img_type) === "exterior";
      })) === null || _gallery$images$filte === void 0 ? void 0 : _gallery$images$filte.length;
      var interiorImages = (_gallery$images$filte2 = gallery.images.filter(function (item) {
        return (item === null || item === void 0 ? void 0 : item.img_type) === "interior";
      })) === null || _gallery$images$filte2 === void 0 ? void 0 : _gallery$images$filte2.length;
      return exteriorImages < 5 || interiorImages < 5;
    }
    return false;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.container, " ").concat(hasTowPrises ? stl.hasTowPrises : "")
  }, /*#__PURE__*/React.createElement("strong", {
    className: stl.title
  }, t("سعر الكاش", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("div", {
    className: [stl.priceContainer].join(" ")
  }, (priceSection === null || priceSection === void 0 ? void 0 : priceSection.none_vat_price) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.priceContSub
  }, /*#__PURE__*/React.createElement("p", null, priceSection === null || priceSection === void 0 ? void 0 : (_priceSection$none_va = priceSection.none_vat_price) === null || _priceSection$none_va === void 0 ? void 0 : _priceSection$none_va.header), /*#__PURE__*/React.createElement("strong", {
    className: [stl.blkColor, "interActiveGreen"].join(" ")
  }, priceSection === null || priceSection === void 0 ? void 0 : (_priceSection$none_va2 = priceSection.none_vat_price) === null || _priceSection$none_va2 === void 0 ? void 0 : _priceSection$none_va2.text, /*#__PURE__*/React.createElement("span", {
    className: "interActiveGreen !text-3xl"
  }, priceSection === null || priceSection === void 0 ? void 0 : priceSection.currency))), /*#__PURE__*/React.createElement("div", {
    className: stl.sepMe
  })), (priceSection === null || priceSection === void 0 ? void 0 : priceSection.vat_price) && /*#__PURE__*/React.createElement("div", {
    className: stl.priceContSub
  }, hasTowPrises && /*#__PURE__*/React.createElement("p", null, priceSection === null || priceSection === void 0 ? void 0 : (_priceSection$vat_pri = priceSection.vat_price) === null || _priceSection$vat_pri === void 0 ? void 0 : _priceSection$vat_pri.header), /*#__PURE__*/React.createElement("strong", {
    className: "interActiveGreen"
  }, priceSection === null || priceSection === void 0 ? void 0 : (_priceSection$vat_pri2 = priceSection.vat_price) === null || _priceSection$vat_pri2 === void 0 ? void 0 : _priceSection$vat_pri2.text, /*#__PURE__*/React.createElement("span", {
    className: "interActiveGreen !text-3xl"
  }, priceSection === null || priceSection === void 0 ? void 0 : priceSection.currency)), (priceSection === null || priceSection === void 0 ? void 0 : (_priceSection$old_pri = priceSection.old_price) === null || _priceSection$old_pri === void 0 ? void 0 : _priceSection$old_pri.text_with_vat) && /*#__PURE__*/React.createElement("strong", {
    className: [stl.priceCashON, stl.oldPrice, "interActiveGreen"].join(" ")
  }, priceSection === null || priceSection === void 0 ? void 0 : (_priceSection$old_pri2 = priceSection.old_price) === null || _priceSection$old_pri2 === void 0 ? void 0 : _priceSection$old_pri2.text_with_vat, /*#__PURE__*/React.createElement("span", {
    className: "interActiveGreen !text-2xl"
  }, priceSection === null || priceSection === void 0 ? void 0 : priceSection.currency)))), /*#__PURE__*/React.createElement("div", {
    className: stl.note
  }, !hasTowPrises && /*#__PURE__*/React.createElement("p", {
    className: "interActiveGray"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/check-mark.svg",
    width: 24,
    height: 24,
    alt: "check-mark"
  }), " ", priceSection === null || priceSection === void 0 ? void 0 : (_priceSection$vat_pri3 = priceSection.vat_price) === null || _priceSection$vat_pri3 === void 0 ? void 0 : _priceSection$vat_pri3.header), /*#__PURE__*/React.createElement("span", {
    className: stl.startStryNow,
    onClick: function onClick() {
      ShowStory && ShowStory();
    }
  }, t("كيف تشتري سيارتك من سيارة؟", {
    ns: "web_post_view"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "w-full mb-4"
  }, (details === null || details === void 0 ? void 0 : (_details$color_varian = details.color_variants) === null || _details$color_varian === void 0 ? void 0 : _details$color_varian.length) > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CarColorVariation, {
    colors: details === null || details === void 0 ? void 0 : details.color_variants,
    onColorClick: function onColorClick(color) {
      var _color$name_en;
      trackEvents("car_color_selected", {
        referral_location: "post_details",
        post_id: postId,
        selected_color: (_color$name_en = color === null || color === void 0 ? void 0 : color.name_en) !== null && _color$name_en !== void 0 ? _color$name_en : '',
        post_make: g4_data === null || g4_data === void 0 ? void 0 : g4_data.post_make,
        post_model: g4_data === null || g4_data === void 0 ? void 0 : g4_data.post_model
      });
      navigateToHard("/cardetail/".concat(color.post_id));
    },
    currentColorCode: details === null || details === void 0 ? void 0 : (_details$details_card = details.details_card) === null || _details$details_card === void 0 ? void 0 : (_details$details_card2 = _details$details_card.exterior_color) === null || _details$details_card2 === void 0 ? void 0 : _details$details_card2.code,
    currentColorName: details === null || details === void 0 ? void 0 : (_details$details_card3 = details.details_card) === null || _details$details_card3 === void 0 ? void 0 : (_details$details_card4 = _details$details_card3.exterior_color) === null || _details$details_card4 === void 0 ? void 0 : _details$details_card4.name,
    showDisclaimer: showImagesDisclaimer()
  }))), !hidePaymentBtn && /*#__PURE__*/React.createElement("div", {
    className: stl.btnsArea
  }, reserved == 1 ? /*#__PURE__*/React.createElement("div", {
    className: stl.reservedCarBox
  }, /*#__PURE__*/React.createElement("strong", null, t("هذه السيارة محجوزة", {
    ns: "web_post_view"
  })), !showNumbers && /*#__PURE__*/React.createElement("span", {
    className: "greenTextBtn",
    onClick: function onClick() {
      setShowNumbers(true);
    }
  }, t("تواصل مع مندوب المبيعات", {
    ns: "web_post_view"
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
    className: ["greenBtn"].join(" "),
    to: createUrl("/checkout/shop-apply?post_id=".concat(postId)),
    onClick: function onClick() {
      cashCheckout1Event("checkout_lead", g4_data);
      trackEvents("book_car", _objectSpread(_objectSpread({}, g4_data), {}, {
        post_trim: g4_data === null || g4_data === void 0 ? void 0 : g4_data.post_ext
      }));
    }
  }, t("احجزها الآن", {
    ns: "web_post_view"
  }), " ", "".concat(arboun, " "), /*#__PURE__*/React.createElement("span", {
    className: "!text-xl"
  }, t("ريال", {
    ns: "web_common"
  }))), !showNumbers && /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      setShowNumbers(true);
    },
    className: ["greenTextBtn", stl.reserveNowBtn].join(" ")
  }, t("اتصل بنا للحجز", {
    ns: "web_post_view"
  }))), showNumbers && /*#__PURE__*/React.createElement("div", {
    className: stl.callUsBy
  }, /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      setShowNumbers(false);
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/bundles/close_search.svg",
    alt: ""
  })), /*#__PURE__*/React.createElement("strong", null, t("تواصل معنا عن طريق", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("a", {
    href: "tel:".concat(contactNumbers.callCenterCallNumber),
    className: stl.SOLcallus,
    onClick: function onClick() {
      //  onlineContactEvent("call", "Car Details", postId);
      trackEvents("online_contact", {
        post_id: postId,
        contact_type: "call",
        contact_location: "Car Details"
      });
      onPushDataLayer("postdetails.lead", "Post Details", "Lead", "Call");
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/bundles/Call.svg",
    alt: ""
  }), /*#__PURE__*/React.createElement("span", null, t("اتصال", {
    ns: "web_post_view"
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      direction: "ltr"
    }
  }, contactNumbers.callCenterDisplayNumber)), /*#__PURE__*/React.createElement("a", {
    href: "https://api.whatsapp.com/send?phone=".concat(contactNumbers.whatsappCallNumber, "&amp;"),
    rel: "noopener noreferrer",
    target: "_blank",
    className: stl.SOLwhatus,
    onClick: function onClick() {
      //onlineContactEvent("whatsapp", "Car Details", postId);
      trackEvents("online_contact", {
        post_id: postId,
        contact_type: "whatsapp",
        contact_location: "Car Details"
      });
      onPushDataLayer("postdetails.lead", "Post Details", "Lead", "WhatsApp");
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/bundles/wpImg.svg",
    alt: "",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("span", null, t("واتساب", {
    ns: "web_post_view"
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      direction: "ltr"
    }
  }, contactNumbers.whatsappDisplayNumber))))));
};
export default CashPayment;